import { PaymentProcessorAccountConfigurationBase } from '../payment-processor-account-configuration-base';

export class CertifiedPaymentsPaymentProcessorAccountConfiguration extends PaymentProcessorAccountConfigurationBase {
  id: string;
  accessCode: string;
  bureauCode: string;
  paymentType: any;

  constructor(
    options?: Partial<CertifiedPaymentsPaymentProcessorAccountConfiguration>
  ) {
    super(options);
  }
}
